import React from 'react';

import MuiTabPanel, {
  TabPanelProps as MuiTabPanelProps,
} from '@mui/lab/TabPanel';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const TabPanel = withCoreProps<TabPanelProps>(
  ({
    children,
    className,
    ...otherProps
  }: React.PropsWithChildren<TabPanelProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiTabPanel {...otherProps} className={clsxClass}>
        {children}
      </MuiTabPanel>
    );
  },
);

export interface TabPanelProps extends MuiTabPanelProps, CoreProps {}
